/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_SubmitInputs */

const fr_auth_forgot_submit = /** @type {(inputs: Auth_Forgot_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer le lien`)
};

const en_auth_forgot_submit = /** @type {(inputs: Auth_Forgot_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send the link`)
};

/**
* | output |
* | --- |
* | "Send the link" |
*
* @param {Auth_Forgot_SubmitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_submit = /** @type {((inputs?: Auth_Forgot_SubmitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_SubmitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_submit(inputs)
	return fr_auth_forgot_submit(inputs)
});